const brandedCards = {
    [process.env.REACT_APP_MERCHANT_ID_BEST_BUY]: {
        merchantCardBackgroundColor: '#0046BE',
        merchantCardBackgroundImage: null,
        merchantCardLogo: require('assets/images/digitalCard/logo_BestBuy.svg'),
        merchantCardLogoRightPosition: '32%',
        merchantCardLogoTopPosition: '8%',
        merchantLogoWidthPercentage: '35.5%',
        merchantName: 'Best Buy',
        showDisclaimer: false,
        showFairstoneLogo: true,
    },
};

const defaultStyle = {
    merchantCardBackgroundColor: null,
    merchantCardBackgroundImage: `url(/images/fairstone-digital-card-background.jpg)`,
    merchantCardLogo: require('assets/images/digitalCard/logo_fairstone_bi_card_reversed.svg'),
    merchantCardLogoRightPosition: '5%',
    merchantCardLogoTopPosition: '10%',
    merchantLogoWidthPercentage: '45.3%',
    merchantName: 'Fairstone',
    showDisclaimer: true,
    showFairstoneLogo: false,
};

const getCardStyles = (merchantNumber) => brandedCards[merchantNumber] || defaultStyle;

export default getCardStyles;
